import React, { useEffect } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
} from '@mui/material';
import { useFormik, FormikProvider, Form } from 'formik';
import { productCategoryValidationSchema } from 'src/util/validationSchemas';
import { useList, useMutate } from 'src/hooks/useFetch.hook';
import { Loader } from "../Loader";
import { productCategoryUrl } from 'src/react-query/endPoints';
import { BaseTable } from '../BaseTable/BaseTable';
import { ProductCategoryListColumns } from './Product.constants';

// Style object reused from your existing modal
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '600px',
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4,
};

// Utility function to capitalize each word
function capitalizeWords(str) {
  return str.replace(/\b\w+/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}

export default function CategoryModal({ open, onClose }) {
  const { mutate, isLoading } = useMutate('productCategory');
  const { data, isFetching, refetch } = useList('productCategory')

  const onSubmit = (values, { resetForm }) => {
      const mutateObject = {
          url: productCategoryUrl,
          method: "POST",
      };
  
      // if (categoryId && !is.nullOrUndefined(categoryId)) {
      //     mutateObject.method = "PUT";
      //     mutateObject.url = getProductCategoryUrlId(categoryId);
      // }
      mutate(
          {
          url: mutateObject.url,
          method: mutateObject.method,
          body: values,
          },
          { onSuccess }
      );
      resetForm();
  }

  const onSuccess = () => {}

  // Formik setup
  const formik = useFormik({
    initialValues: { category: '' },
    validationSchema: productCategoryValidationSchema,
    onSubmit
  });

  const {
    errors,
    touched,
    values,
    handleChange,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
    setErrors,
  } = formik;

  // Reset form when modal closes
  useEffect(() => {
    if (!open) formik.resetForm();
  }, [open]);

  if(isLoading) {
    return <Loader />
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="category-modal-title"
    >
      <Box sx={style}>
        <Typography variant="h4" gutterBottom>
          Manage Categories
        </Typography>
        <FormikProvider value={formik}>
          <Form>
            <TextField
              label="New Category"
              variant="outlined"
              fullWidth
              name="category"
              value={values.category}
              onChange={handleChange}
              {...getFieldProps("category")}
              error={touched.category && Boolean(errors.category)}
              helperText={touched.category && errors.category}
              sx={{ my: 2 }}
              style={{textTransform: 'capitalize'}}
            />
            <div style={{ marginBottom: '20px' }}>
              <Button
                variant="contained"
                type="submit"
                sx={{ mr: 2 }}
                disabled={formik.isSubmitting}
              >
                Save
              </Button>
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
            </div>
          </Form>
        </FormikProvider>
        {/* Table Section */}
        <Typography variant="subtitle1" gutterBottom>
          All Categories
        </Typography>
        <BaseTable
            rows={Array.isArray(data) ? data : []}
            columns={ProductCategoryListColumns(refetch)}
            loading={isFetching}
            getRowId={(row) => row.id}
            pageSize={5}
        />
      </Box>
    </Modal>
  );
}
